import React, { FC } from "react";
import { styled } from "@mui/system";
import { COLORS, RADII } from "../../common/consts";

/**
 * A plain checkbox in the brand colour, Outreach's size (16px). A real input,
 * so it keeps keyboard focus and its label click for free.
 */
const Box = styled("input")`
  appearance: none;
  flex: 0 0 auto;
  width: 16px;
  height: 16px;
  margin: 0;
  border: 1.5px solid var(--color-inputOutline, ${COLORS.inputOutline});
  border-radius: ${RADII.sm};
  background-color: var(--color-backgroundWhite, ${COLORS.backgroundWhite});
  background-position: center;
  background-repeat: no-repeat;
  background-size: 12px 12px;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease;

  &:hover:not(:disabled) {
    border-color: var(--color-foregroundBrand, ${COLORS.foregroundBrand});
  }

  &:checked {
    border-color: var(--color-toggleActive, ${COLORS.toggleActive});
    background-color: var(--color-toggleActive, ${COLORS.toggleActive});
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M20 6L9 17L4 12' stroke='white' stroke-width='3' stroke-linecap='round' stroke-linejoin='round' fill='none'/%3E%3C/svg%3E");
  }

  &:focus-visible {
    outline: 2px solid var(--color-foregroundBrand, ${COLORS.foregroundBrand});
    outline-offset: 2px;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export interface CheckboxProps {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  id?: string;
  "aria-label"?: string;
  className?: string;
}

const Checkbox: FC<CheckboxProps> = ({ checked = false, onChange, ...rest }) => (
  <Box type="checkbox" checked={checked} onChange={(e) => onChange?.(e.target.checked)} {...rest} />
);

export default Checkbox;
